import { AxiosResponse } from "axios";
import environment from "../config";
import MemberDetails from "../entities/MemberDetails";
import axiosUtil from "../utils/helpers/axiosUtil";
import dal from "../middleware/DAL";

export const MEMBER_NOT_VERIFY_ANSWERS_FOR_QUESTIONS =
  "MEMBER_NOT_VERIFY_ANSWERS_FOR_QUESTIONS";

  export const UPDATE_DETAILS_DEFAULT_ERROR = "UPDATE_DETAILS_DEFAULT_ERROR";

export const Max_Users_With_Same_CellPhone = "Max_Users_With_Same_CellPhone";

export const Max_Users_With_Same_Email = "Max_Users_With_Same_Email";

export async function UpdateMemberDetails(memberDetails: any) {
  if (memberDetails) {
    try {
      const body: MemberDetails = {
        cityCode: memberDetails.cityCode,
        street: memberDetails.street,
        number: memberDetails.number,
        apartmentNumber: memberDetails.apartmentNumber,
        postCode: memberDetails.postCode,
        postOfficeCode: memberDetails.postOfficeCode,
        phone: memberDetails.phone,
        cellPhone: memberDetails.cellPhone,
        email: memberDetails.email,
        emailAcceptAgreementCode: memberDetails.emailAcceptAgreementCode,
        digitalDepositInfoInd: memberDetails.digitalDepositInfoInd,
      };
      
      const path = environment.BASE_URL + "MemberDetails/UpdateMemberDetails";
      const res: AxiosResponse<any> = await dal.post(path, body);
      if (axiosUtil.isSuccess(res)) return true;
      if (res?.data?.errorCode === 25) {
        return Max_Users_With_Same_CellPhone;
      } else if (res?.data?.errorCode === 24) {
        return Max_Users_With_Same_Email;
      } else if (res?.data?.errorCode === 56) {
        return MEMBER_NOT_VERIFY_ANSWERS_FOR_QUESTIONS;
      } else {
        return UPDATE_DETAILS_DEFAULT_ERROR;
      }
      
    } catch (err) {
      console.log(err);
    }
  }
  return false;
}

export const updateMemberDetailsUtil = {
  isSuccess: (isDetailsUpdated: boolean | string) =>
    typeof isDetailsUpdated === "boolean" && isDetailsUpdated,

  isNotVerifyAnswersError: (isDetailsUpdated: boolean | string) =>
    typeof isDetailsUpdated === "string" &&
    isDetailsUpdated === MEMBER_NOT_VERIFY_ANSWERS_FOR_QUESTIONS,
};
